export default __webpack_public_path__ + "static/media/Aleska-DSR.53eb544a.jpg";